<template>
  <div>
    <div class="hred">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>
    <div style="    font-weight: 700;
    font-style: normal;
    font-size: 36px;text-align: center;margin-top: 40px;">机构评分申诉
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <img class="img " src="@/images/biaodan/u113.png">
    </div>
  </div>
  <!-- 表格 -->

    <div style="display: flex;margin-left: 30px;">
      <div class="kuang n1">机构名称</div>
      <div class="kuang n2">{{ this.form.orgName }}</div>
      <div class="kuang n3">法人姓名</div>
      <div class="kuang n4">
        {{ this.form.orgHeader }}
      </div>
    </div>
    <div style="display: flex;margin-left: 30px;">
      <div class="kuang n1">手机号码</div>
      <div class="kuang n2">{{ this.form.orgHeaderPhone }}</div>
      <div class="kuang n3">身份证号</div>
      <div class="kuang n4">
        {{ this.form.idcardNo }}
      </div>
    </div>
    <div style="display: flex;margin-left: 30px;">
      <div class="kuang n1">所属地区</div>
      <div class="kuang n2">
        {{ this.form.area }}
      </div>
        <div class="kuang n3">评分审核状态</div>
        <div class="kuang n4" style="color: red;font-weight: bold">{{ this.form.verifyMsg }}</div>
    </div>
    <div style="display: flex;margin-left: 30px;">
        <div class="kuang n1">负责人</div>
        <div class="kuang n2">{{ this.form.ownerName }}</div>
        <div class="kuang n3">负责人手机号</div>
        <div class="kuang n4">
            {{ this.form.ownerPhone }}
        </div>
    </div>
<!--    <div style="display: flex;height: 300px;margin-left: 30px;" v-if="this.form.auditStatus!=0">
      <div class="kuang n6">申诉原因</div>
      <div class="kuang n5" style=" height: auto;word-wrap:break-word;">
        <el-input type="textarea" ></el-input>
      </div>
    </div>-->
    <el-form>
        <el-row>
            <el-col :span="23" >
                <el-form-item label-width="110px" style="margin-top: 40px;"  label="申诉原因：" prop="complainRemark">
                    <el-input type="textarea" :rows="14" class="reason"  placeholder="请填写申诉原因" v-model="form.complainRemark" @input="inputnow"/>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>

  <el-button style="cursor: pointer;position: relative;top:30px;left: 30%" type="danger" size="medium"
              @click="toIndex">返回首页
  </el-button>
  <el-button style="cursor: pointer;position: relative;top:30px;left: 50%" type="danger" size="medium"
             @click="submit">提交申诉
  </el-button>


  <!-- Unnamed (矩形) -->
  <div id="u58" class="ax_default label">
    <div id="u58_div" class=""></div>
    <div id="u58_text" class="text ">
      <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
      <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
      <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
    </div>
  </div>
</template>

<script>
import {getSysUserInfoByDeptId,complainScore} from '@/requst/api'
import {ElMessage} from "element-plus";
export default {
  name: 'BaoBei',
  data() {
    return {
      form: {
        orgName: '',
        orgHeader: '',
        orgHeaderPhone: '',
        idcardNo: '',
        establishDate: '',
        auditStatus: '',
        auditRemark: '',
        createTime: '',
        updateTime: '',
      },
    }
  },
  created() {
    let date = JSON.parse(localStorage.getItem('cxjg'))
    this.form.orgName = date.orgName
    this.form.orgHeader = date.orgHeader
    this.form.orgHeaderPhone = date.orgHeaderPhone
    this.form.idcardNo = date.idcardNo
    this.form.deptId = date.deptId
    this.form.area = date.provinceName+" "+date.cityName+ " " + date.countyName
    this.form.verifyMsg = date.scoreAuditStatus == '0' ? '未提交评分' : (date.scoreAuditStatus == '1' ? '待审核' : (date.scoreAuditStatus == '2' ? '审核中' : "已审核"))

  },
    mounted() {
       console.log(this.form.deptId)
        let param={
           deptId: this.form.deptId
        }
        //查询所属区域负责人信息
        getSysUserInfoByDeptId(param).then(res=>{
            console.log(res)
            if(!res.data){
                ElMessage.error(res.header.msg)
            }
            if(res.data){
                this.form.ownerName = res.data.nickName;
                this.form.ownerPhone = res.data.phonenumber;
            }
        })
    },
    methods: {
      inputnow() {
        localStorage.setItem('jindu', JSON.stringify(this.form))
      },
      toIndex() {
        this.$router.push('/')
      },
      submit() {
        let _this = this
        let data = JSON.parse(localStorage.getItem('cxjg'))

        localStorage.setItem('orgId', data.id)
          let param={
              id: data.id,
              complainAuditStatus:1,
              complainRemark: this.form.complainRemark
          }
          complainScore(param).then(res=>{
              console.log(res)
              if(res.code != 200){
                  ElMessage.error(res.msg)
              }
              if(res.code == 200){
                  let orgInfo = JSON.parse(localStorage.getItem('cxjg'))
                  orgInfo.complainAuditStatus=1;
                  orgInfo.complainRemark=this.form.complainRemark;
                  localStorage.setItem('cxjg',JSON.stringify(orgInfo))
                  _this.$router.push('/scoreResult')
              }
          })


      },
  }
}
</script>
<style scoped>
.kuang {
  border: 0.1px solid #cccccc;
  border-width: thin;
}
.reason{
    height: 300px;
}

.l1 {
  width: 400px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  top: 272px;
  left: 240px;

}

.l2 {
  width: 400px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  top: 312px;
  left: 240px;
}

.l3 {
  width: 400px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  top: 352px;
  left: 240px;
}

.l4 {
  width: 400px;
  height: 50px;
  position: absolute;
  top: 392px;
  left: 240px;
  line-height: 50px;
}

.l5 {
  width: 400px;
  height: 50px;
  position: absolute;
  top: 432px;
  left: 240px;
  line-height: 50px;
}

.l6 {
  width: 400px;
  height: 50px;
  position: absolute;
  top: 472px;
  left: 240px;
  line-height: 50px;
}

.l7 {
  width: 324px;
  height: 50px;
  position: absolute;
  top: 562px;
  left: 572px;
  line-height: 50px;
}

.l8 {
  width: 324px;
  height: 50px;
  position: absolute;
  top: 562px;
  left: 660px;
  line-height: 50px;
}

.l9 {
  width: 324px;
  height: 50px;
  position: absolute;
  top: 562px;
  left: 720px;
  line-height: 50px;
}

.no {
  width: 324px;
  height: 50px;
  position: absolute;
  top: 238px;
  left: 590px;
  line-height: 50px;
}

#biaoge {
  background-image: url("../assets/zhengshu.png");
  background-size: 100%;
  width: 879px;
  height: 662px;
  position: relative;
  font-size: 18px;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  font-weight: bolder;

}

.n1 {
  width: 150px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-weight: bold;
}

.n2 {
  width: 330px;
  height: 50px;
  text-align: center;
  line-height: 50px;
}

.n3 {
  width: 132px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-weight: bold;
}

.n4 {
  width: 324px;
  height: 50px;
  text-align: center;
  line-height: 50px;
}

.n5 {
  width: 790px;
  height: 200px;
  text-align: center;
  line-height: 50px;
  overflow-y: auto;
}

.n6 {
  width: 150px;
  height: 200px;
  text-align: center;
  line-height: 200px;
  font-weight: bold;
}

#u58 {
  margin-top: 40px;
  background: rgb(242, 242, 242);
  height: 120px;
  padding: 10px 0;
  font-size: 16px;
}

#u51_img {
  width: 1000px;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

.jindu {
  margin-top: 20px;
  display: flex;
  margin-left: 100px;
}

.jindu .p1 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #CCCCCC;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span1 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #CCCCCC;
}

.jindu .p2 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #FF0000;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span2 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #FF0000;
}


.imgx {
  margin-left: -25px;
}

.jindu div {
  margin-left: 20px;
}

.hang {
  margin-left: 150px;
  color: black;
  font-size: 16px;
}

.inputs {
  width: 40%;
  margin-left: 10px;
}

.selects {
  width: 40%;
  margin-left: 10px;
}

.xing {
  color: red;
  font-size: 18px;
  margin-left: 5px;
}

.bei {
  font-size: 16px;
  margin-left: 30px;
  color: #c9c9c9;
}


.el-form-item label {
  color: black;
  font-size: 16px;
}

.buttons {
  cursor: pointer;
  border-width: 0px;
  width: 15%;
  height: 30px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
}

.buttons1 {
  cursor: pointer;
  border-width: 0px;
  width: 40px;
  text-align: center;
  height: 30px;
  background: inherit;
  background-color: #409eff;
  border: none;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons2 {
  cursor: pointer;
  position: relative;
  left: 37%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons3 {
  position: relative;
  left: 20%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 51, 51, 1);
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FF3333;
}


</style>
